import { Directive, HostListener } from '@angular/core';

import { LogoutService } from './logout.service';

@Directive({
  selector: '[shrdUtcLogout]'
})
export class LogoutDirective {
  @HostListener('click')
  private onClick() {
    this.logoutService.dispatchLogout();
  }

  constructor(private readonly logoutService: LogoutService) {}
}
